import {BaseCriteriaModel} from '../base-criteria.model';
import {Optional} from 'typescript-optional';

export class AppletCatalogLinkQueryCriteriaClass extends BaseCriteriaModel {
  link_type?: Optional<string> = Optional.empty();
  applet_hdr_guid?: Optional<string> = Optional.empty();
  catalog_hdr_guid?: Optional<string> = Optional.empty();
  catalog_line_guid?: Optional<string> = Optional.empty();
  tenant_guid?: Optional<string> = Optional.empty();
}

export class AppletCatalogLinkCriteriaModelQuery {
  query = '';

  constructor(appletCatalogLinkCriteriaModel: AppletCatalogLinkQueryCriteriaClass) {

    if (!appletCatalogLinkCriteriaModel) {
      return;
    }

    this.query += appletCatalogLinkCriteriaModel.link_type.filter(x => x !== '').map(x => '&link_type=' + x).orElse('');
    this.query += appletCatalogLinkCriteriaModel.applet_hdr_guid.filter(x => x !== '').map(x => '&applet_hdr_guid=' + x).orElse('');
    this.query += appletCatalogLinkCriteriaModel.catalog_hdr_guid.filter(x => x !== '').map(x => '&catalog_hdr_guid=' + x).orElse('');
    this.query += appletCatalogLinkCriteriaModel.catalog_line_guid.filter(x => x !== '').map(x => '&catalog_line_guid=' + x).orElse('');
    this.query += appletCatalogLinkCriteriaModel.tenant_guid.filter(x => x !== '').map(x => '&tenant_guid=' + x).orElse('');

    this.query += '&status=' + appletCatalogLinkCriteriaModel.status;
    this.query += '&orderBy=' + appletCatalogLinkCriteriaModel.orderBy;
    this.query += '&order=' + appletCatalogLinkCriteriaModel.order;
    this.query += '&offset=' + appletCatalogLinkCriteriaModel.offset + '&limit=' + appletCatalogLinkCriteriaModel.limit;
  }
}
